import choiceSequenceHandler from '../../../../qti/utils/ChoiceSequenceHandler';
import scorableItemNumberingService from '../../../../services/questionView/ScorableItemNumberingService';
import questionReader from '../../../../store/readHelpers/QuestionReader';
import sessionReader from '../../../../store/readHelpers/SessionReader';
import settingsReader from '../../../../store/readHelpers/SettingsReader';

const matchInteractionSelector = {
    selectAlternatives(model, choiceSequence) {
        if (choiceSequence) {
            // sorting columns
            const sequenceColumns = choiceSequence.slice(0, model.alternatives[0].length);
            choiceSequenceHandler.sortAlternativesAccordingToChoiceSequence(model.alternatives[0], sequenceColumns);

            // sorting rows
            const sequenceRows = choiceSequence.slice(model.alternatives[0].length);
            choiceSequenceHandler.sortAlternativesAccordingToChoiceSequence(model.alternatives[1], sequenceRows);
        }

        return model.alternatives;
    },

    selectShowHorizontalFlagging(isInverted) {
        return isInverted
            && settingsReader.isFlaggingEnabled()
            && sessionReader.isInteractive()
            && scorableItemNumberingService.useNumberPerInteraction();
    },

    selectProps(ownProps) {
        const {
            choiceSequence,
            model,
        } = ownProps;

        const alternatives = this.selectAlternatives(model, choiceSequence);
        const isInverted = questionReader.isInvertedMatchingAlternatives(alternatives);

        return {
            isInverted,
            isPaperBased: sessionReader.isPrintStylePaperBased(),
            matchColumns: alternatives[1],
            matchRows: alternatives[0],
            showHorizontalFlagging: this.selectShowHorizontalFlagging(isInverted),
        };
    },
};

export default matchInteractionSelector;
